<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/service/topic_icon.svg" />
      <h1>Service Facilities</h1>
      <p>
        Ensure that places with high foot traffic are managed to be safer
        <br />
        and more comfortable.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Fitness Centers </span>
        <span class="tag"> #Karaokes </span>
        <span class="tag"> #Spa </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/service/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Service Facilities"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="CESCO [BusinessSectors] Service Facilities" />
            <div class="title">
              <h3>Reliable Disinfection Against Viruses and Harmful Bacteria</h3>
            </div>
            <p class="description">Activities such as removing masks or spreading droplets occur often, making me worry everyday.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_nature.svg" alt="CESCO [BusinessSectors] Service Facilities" />
            <div class="title">
              <h3>Comfortable Space Management</h3>
            </div>
            <p class="description">I am concerned about sweat and musty odors due the nature of our facility.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_speaker.svg" alt="CESCO [BusinessSectors] Service Facilities" />
            <div class="title">
              <h3>The Need for Differentiated Marketing</h3>
            </div>
            <p class="description">I want to actively promote the establishment as hygienic to reassure visitors it is safe.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>We provide system management optimized for specific spaces such as fitness center.</h4>
            <p>
              Through personalized consultation visits, CESCO manages air quality in each enclosed space, ensuring a fresh environment even in areas
              that are difficult to ventilate.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/service/border_content_01.png" alt="CESCO [BusinessSectors] Service Facilities" />
          </div>
          <div>
            <img src="@/assets/images/location/service/border_content_02.png" alt="CESCO [BusinessSectors] Service Facilities" />
          </div>
          <div class="border-content">
            <h4>Enjoy customized fragrance management in areas prone to sweating, underground facilities, and enclosed spaces.</h4>
            <p>
              We remove odors from unventilated, enclosed indoor spaces and maintain a constantly fresh environment through a comprehensive air
              quality management system.
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Service Facilities" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Service Facilities" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Service Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Service Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_scent.svg" alt="CESCO [BusinessSectors] Service Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Fragrance Consulting Solution</h3>
              </div>
              <p class="description">Develop a lasting and symbolic fragrance that becomes synonymous with your business.</p>
            </div>

            <router-link to="/solution/service/scent"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Service Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/service/background_img_01.png'),
    products: [
      {
        posX: '44.6875rem',
        posY: '4.245rem',
        mobilePosX: '59.5%',
        mobilePosY: '16%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_01.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      },
      {
        posX: '59.75rem',
        posY: '23.87rem',
        mobilePosX: '78.5%',
        mobilePosY: '65%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_02.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_02.png'),
    products: [
      {
        posX: '54.5625rem',
        posY: '19.995rem',
        mobilePosX: '72%',
        mobilePosY: '59%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_03.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_03.png'),
    products: [
      {
        posX: '60.1875rem',
        posY: '21.245rem',
        mobilePosX: '78.5%',
        mobilePosY: '66%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_04.png'),
    products: [
      {
        posX: '59.75rem',
        posY: '18.1825rem',
        mobilePosX: '79%',
        mobilePosY: '60%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_05.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_05.png'),
    products: [
      {
        posX: '49.375rem',
        posY: '7.12rem',
        mobilePosX: '65%',
        mobilePosY: '23%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_06.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_06.png'),
    products: [
      {
        posX: '23.4375rem',
        posY: '17.9325rem',
        mobilePosX: '31.5%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_07.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/service/background_img_08.png'),
    products: [
      {
        posX: '16.625rem',
        posY: '11.745rem',
        mobilePosX: '23%',
        mobilePosY: '33%',
        productInfo: {
          image: require('@/assets/images/location/service/product_img_09.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Service Facilities',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Service Facilities. Ensure that places with high foot traffic are managed to be safer and more comfortable.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
